<template>
  <div>
    <div v-if="seatRequired" class="iw-layout-grid__row seat-picker__row">
      <app-image
        :fall-back-image-path="fallBackImagePath"
        :image-path="venueInfo.imageUrl"
        :alt="'venue-image'"
        class="image_container iw-layout-grid__col--span-8 iw-layout-grid__col--offset-3"
      />
      <h2 class="iw-page-title iw-layout-grid__col--span-8 iw-layout-grid__col--offset-3 seat-picker__row__title">
        Choose your seat
      </h2>
      <div
        v-if="isSeatSelected && vendorsList && vendorsList.length === 0"
        class="no-vendors-error iw-layout-grid__col--span-8 iw-layout-grid__col--offset-3"
      >
        <img src="@/assets/images/exclamation-circle2.svg" class="exclamation-circle" />
        <div class="error-message">Sorry, but there are no vendors currently serving your selection.</div>
      </div>
      <div class="iw-layout-grid__col--span-8 iw-layout-grid__col--offset-3">
        <seat-picker-form :seat-selected="seatSelected" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SeatPickerForm from "./seat-picker-form/SeatPickerForm";
import { MODAL, showDialog, ROUTE_NAMES } from "@/utils";
import VENUE_IMG_FALLBACK from "@/assets/images/vendor_missing.svg";
import AppImage from "@/components/base/app-image/AppImage";

export default {
  name: "SeatPicker",
  components: {
    AppImage,
    SeatPickerForm
  },
  data() {
    return {
      isSeatSelected: false,
      fallBackImagePath: VENUE_IMG_FALLBACK
    };
  },
  computed: {
    ...mapGetters({
      vendorsList: "vendor/getVendorsList",
      venueInfo: "venue/getVenueInfo",
      vendorAliasPlural: "venue/getVendorAliasPlural",
      seatRequired: "venueSettings/seatRequired",
      activeVendor: "vendor/getActiveVendor",
      isLoginAllowed: "venueSettings/isLoginAllowed"
    })
  },
  methods: {
    ...mapActions({
      clearShoppingCart: "cart/clearShoppingCart"
    }),
    clearCartAndNavigateVendorSelection() {
      this.clearShoppingCart();
      this.$modal.hide(MODAL.dialogName);
      this.navigateToVendorSelection();
    },
    // redirection to single vendor is handled in router
    navigateToVendorSelection(cartHasItems) {
      if (this.$route?.params?.returnTo && cartHasItems) {
        this.$router.push({ name: this.$route.params.returnTo });
        return;
      }
      this.$router.push({ name: ROUTE_NAMES.VENDOR_PICKER });
    },
    seatSelected(cartHasItems) {
      this.isSeatSelected = true;
      if (!this.vendorsList?.length) return;

      try {
        if (cartHasItems) {
          const vendorIndex = this.vendorsList.findIndex(vendor => String(vendor.id) === String(this.activeVendor.id));
          const header = "Warning";
          const message =
            "You have items in your cart from a vendor that does not serve your seat selection, your shopping cart will be cleared.";

          if (vendorIndex === -1) {
            showDialog(
              this,
              header,
              message,
              [
                {
                  title: "Ok",
                  handler: this.clearCartAndNavigateVendorSelection
                }
              ],
              true
            );
          } else {
            this.navigateToVendorSelection(cartHasItems);
          }
        } else {
          this.navigateToVendorSelection(cartHasItems);
        }
      } catch (err) {
        console.log(`Catch router error: ${err}`);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.no-vendors-error {
  display: grid;
  grid-template-columns: 38px auto;
  min-height: 38px;
  border-color: rgb(119, 129, 156);
  border-radius: 10px;
  border-style: solid;
  background-color: rgba(119, 129, 156, 0.1);

  @include respond-to-mobile {
    min-height: 56px;
  }
}
.exclamation-circle {
  display: grid;
  justify-self: center;
  width: 18px;
  height: 18px;
  padding-top: 9px;
}
.error-message {
  display: grid;
  padding-top: 8px;
}
.title {
  box-sizing: border-box;
  max-width: 1250px;
  width: 100%;
  text-transform: uppercase;
  border-bottom: 1px solid #eeeeee;

  &_sub {
    border: none;
  }
}
.seat-picker__row {
  &__title {
    height: 34px;
    display: flex;
  }
  @include respond-to-mobile {
    grid-gap: 16px;
    padding: 16px;
    &__title {
      margin-top: 8px;
    }
  }
}
.image_container {
  height: 306px;
  width: 100%;
  position: relative;
  text-align: center;
  color: $group-3-color-1;
  background-color: $not-found-image-background-color;
  margin-top: 12px;
  @include respond-to-mobile {
    margin-top: 0;
    width: 100%;
    height: 172px;
  }
}
.iw-layout-grid__col--offset-3 {
  grid-column-start: 3;
  @include respond-to-mobile {
    grid-column-start: 1;
  }
}
</style>
